'use client'

import { useEffect, useRef, MutableRefObject } from 'react'
import type { Swiper as SwiperType } from 'swiper'

/**
 * Hook for Swiper instance cleanup on unmount
 * Prevents memory leaks by properly destroying Swiper instance
 */
export function useSwiperCleanup(): MutableRefObject<SwiperType | null> {
  const swiperRef = useRef<SwiperType | null>(null)

  useEffect(() => {
    return () => {
      if (swiperRef.current) {
        swiperRef.current.destroy(true, true)
        swiperRef.current = null
      }
    }
  }, [])

  return swiperRef
}
